import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar
} from 'recharts';
import {
  Typography,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  Container
} from '@material-ui/core';
import { makeStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';
import { userAPICountOnBoardReport } from './action';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8884d8', // Custom primary color
    },
    secondary: {
      main: '#ff2d55', 
    },
  },
  typography: {
    fontFamily: 'San Francisco, Arial, sans-serif',
    h5: {
      fontWeight: 600,
    },
  },
});

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    backgroundColor: '#f9f9f9', // Light grey background
    minHeight: '100vh',
  },
  card: {
    margin: 'auto',
    marginTop: theme.spacing(5),
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
  },
  cardContent: {
    padding: theme.spacing(3),
    position: 'relative',
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
  },
  refreshButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
}));

const APIDashboard = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const result = await dispatch(userAPICountOnBoardReport());
    setData(result);
    setLoading(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container className={classes.container}>
        <Card variant="outlined" className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Typography variant="h5" gutterBottom>
              User API Data
            </Typography>
            <IconButton
              color="primary"
              className={classes.refreshButton}
              onClick={fetchData}
              aria-label="Refresh data"
            >
              <RefreshIcon />
            </IconButton>
            {loading ? (
              <div className={classes.loader}>
                <CircularProgress />
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={400}>
                <BarChart data={data}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="api_count" barSize={20} fill="#8884d8" radius={[10, 10, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            )}
          </CardContent>
        </Card>
      </Container>
    </ThemeProvider>
  );
};

export default APIDashboard;
